import { createContext, useContext } from 'react'

type ScenarioStatusContextType = {
  isScenarioActive: boolean
  onChangeIsScenarioActive: (nextValue: boolean) => void
}

// Lives above the top bar so it can react to a scenario being active deeper in the tree.
const ScenarioStatusContext = createContext<ScenarioStatusContextType>({
  isScenarioActive: false,
  onChangeIsScenarioActive: () => {},
})

const useScenarioStatusContext = () => useContext(ScenarioStatusContext)
const Provider = ScenarioStatusContext.Provider

export { Provider, useScenarioStatusContext }
